<template>
	<div style="padding: 80rem 0; background: #f9f9f9; display: flex; justify-content: center; min-height: 100vh; overflow-x: hidden; box-sizing: border-box">
		<div style="width: 1400rem">
			<i class="el-icon-back f-24" @click="$router.back()"></i>
			<span class="f-24 fw-600 ml-16">个人中心</span>

			<div class="mt-30 p-30" style="background: #fff; box-sizing: border-box">
				<el-form :model="form" label-position="left" label-width="104rem" size="small" @submit.native.prevent>
					<div class="f-24 fw-400" style="display: flex; justify-content: space-between; color: #1e3aa2">
						<div style="display: flex; align-items: center">
							<el-image :src="jcxx" style="width: 24rem; height: 24rem; margin-right: 14rem"></el-image>
							基础信息
						</div>
						<el-image :src="form.star_rating === '无' ? xjList[0] : xjList[form.star_rating]" style="width: 158rem; height: 36rem"></el-image>
					</div>
					<div class="mt-24" style="display: flex">
						<div style="display: flex; flex-direction: column; align-items: center">
							<el-image v-if="form.photo" :src="form.photo" style="width: 172rem; height: 223rem; border-radius: 4px; margin-bottom: 16rem">
								<div slot="error" class="image-slot"></div>
							</el-image>
							<el-image v-else :src="img_" style="width: 172rem; height: 223rem; border-radius: 4px; margin-bottom: 16rem"></el-image>
							<el-upload
								:action="$_axios2.defaults.baseURL + '/api/upload/upload'"
								:before-upload="beforeAvatarUpload"
								:data="{ site_size: 20 }"
								:headers="{ authorization: 'Bearer ' + $store.getters.token }"
								:multiple="false"
								:on-error="onChangea"
								:on-success="onChange_"
								:show-file-list="false"
								class="upload-demo"
								list-type="picture"
								name="upload">
								<el-button plain size="small" type="primary">点击上传证件照</el-button>
							</el-upload>
						</div>
						<div style="width: 957rem; margin-left: 40rem; height: 223rem">
							<div style="font-weight: 600; font-size: 32rem; color: #2b3541; display: flex; align-items: center; margin-bottom: 12rem">
								<div>{{ form.clerk_name }}</div>
								<div style="margin-left: 14rem">
									<el-image v-if="form.gender === 2" style="width: 24rem; height: 24rem" :src="$OssAddress+'imgs/nan.svg'" :fit="fit"></el-image>
									<el-image v-if="form.gender === 1" style="width: 24rem; height: 24rem" :src="$OssAddress+'imgs/nv.svg'" :fit="fit"></el-image>
								</div>
							</div>
							<div style="width: 957rem; height: 168rem; display: grid; grid-template-columns: 368rem 341rem 1fr">
								<el-form-item label="所属校区">
									<div>{{ form.school }}</div>
								</el-form-item>
								<el-form-item label="教学岗位">
									<div>{{ form.role_type }}/{{ form.current_role }}</div>
								</el-form-item>
								<el-form-item label="教学学科">
									<div>{{ form.p_subject }}/{{ form.subject }}</div>
								</el-form-item>
								<el-form-item label="任职情况">
									<div>{{ form.employment }}</div>
								</el-form-item>
								<el-form-item label="政治面貌">
									<div>{{ form.political_outlook }}</div>
								</el-form-item>
								<el-form-item label="是否为班主任">
									<div>{{ form.class }}</div>
								</el-form-item>
								<el-form-item label="民族">
									<div>{{ form.nation_text }}</div>
								</el-form-item>
								<el-form-item label="年龄">
									<div>{{ form.age }}</div>
								</el-form-item>
								<el-form-item label="教龄">
									<div>{{ form.teaching_experience }}</div>
								</el-form-item>
								<el-form-item label="入职时间">
									<div>{{ form.entry_time }}</div>
								</el-form-item>
								<el-form-item label="出生日期">
									<div>{{ form.birthday }}</div>
								</el-form-item>
								<el-form-item label="联系方式">
									<div>{{ form.mobile }}</div>
								</el-form-item>
							</div>
						</div>
					</div>

					<div style="display: flex; margin-left: 220rem; margin-top: 40rem; justify-content: space-between; width: 957rem">
						<div style="width: 460rem; height: 190rem; background: #f9f9f9; border-radius: 8rem; padding: 24rem">
							<div style="display: flex; align-items: center">
								<el-image src="/img/selfCenterImg/gr.svg" style="width: 24rem; height: 24rem"></el-image>
								<div style="font-weight: 600; font-size: 24rem; color: #3c3c3c; flex: 1; margin-left: 14rem">专业及院校</div>
							</div>
							<div style="margin-top: 20rem; display: grid; grid-template-columns: 1fr 1fr; gap: 24rem; gap: 30rem">
								<div style="display: flex; align-items: center">
									<span class="credentials-item-key credentials-item-key-left">最高学历</span>
									<span class="credentials-item-val" :title="form.education_text">{{ form.education_text }}</span>
								</div>
								<div style="display: flex; align-items: center">
									<span class="credentials-item-key credentials-item-key-right">是否师范专业</span>
									<span class="credentials-item-val" :title="form.is_normal_text">{{ form.is_normal_text }}</span>
								</div>
								<div style="display: flex; align-items: center">
									<span class="credentials-item-key credentials-item-key-left">毕业院校</span>
									<span class="credentials-item-val" :title="form.graduated_from">{{ form.graduated_from }}</span>
								</div>
								<div style="display: flex; align-items: center">
									<span class="credentials-item-key credentials-item-key-right">所学专业</span>
									<span class="credentials-item-val" :title="form.major">{{ form.major }}</span>
								</div>
							</div>
						</div>
						<div style="width: 460rem; height: 190rem; background: #f9f9f9; border-radius: 8rem; padding: 24rem">
							<div style="display: flex; align-items: center">
								<el-image src="/img/selfCenterImg/zs.svg" style="width: 24rem; height: 24rem"></el-image>
								<div style="font-weight: 600; font-size: 24rem; color: #3c3c3c; flex: 1; margin-left: 14rem">证书及职称</div>
							</div>
							<div style="margin-top: 20rem; display: grid; grid-template-columns: 1fr 1fr; gap: 24rem; gap: 30rem">
								<div style="display: flex; align-items: center">
									<span class="credentials-item-key credentials-item-key-right">是否有资格证</span>
									<span class="credentials-item-val" :title="form.teacher_certificate_text">{{ form.teacher_certificate_text }}</span>
								</div>
								<div style="display: flex; align-items: center">
									<span class="credentials-item-key credentials-item-key-right">教师职称</span>
									<span class="credentials-item-val" :title="form.teacher_title">{{ form.teacher_title }}</span>
								</div>
							</div>
						</div>
					</div>
				</el-form>
			</div>

			<div class="mt-30 p-30" style="background: #fff; box-sizing: border-box">
				<el-form :model="form" label-width="104rem" @submit.native.prevent>
					<div class="f-24 fw-400" style="display: flex; justify-content: space-between; color: #3c3c3c">
						<div style="display: flex; align-items: center">
							<el-image :src="gr" style="width: 24rem; height: 24rem; margin-right: 14rem"></el-image>
							个人简介
						</div>
					</div>

					<div class="mt-24" style="width: 1060rem">
						<el-form-item label="优势标签" required>
							<el-tag v-for="i in form.tags" :key="i" closable style="margin-right: 8rem" @close="onDeleteTag(i)">{{ i }}</el-tag>
							<el-input
								v-if="inputVisible"
								ref="saveTagInput"
								v-model="inputValue"
								class="input-new-tag"
								maxlength="6"
								placeholder="请输入标签"
								size="small"
								style="margin-right: 12rem"
								@blur="handleInputConfirm"
								@keyup.enter.native="handleInputConfirm" />
							<el-button class="button-new-tag" size="small" @click="showInput">+</el-button>
							<div style="font-weight: 400; font-size: 12px; color: #aeaeae; margin-top: -8rem">按回车键保存</div>
						</el-form-item>
						<el-form-item label="个人简介" required>
							<el-input v-model="form.summary" :autosize="{ minRows: 4, maxRows: 12 }" maxlength="300" placeholder="请输入个人简介" show-word-limit type="textarea"></el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>

			<div style="margin-top: 24rem">
				<el-button type="primary" @click="onSubmit">提交</el-button>
				<el-button @click.prevent="$router.back()">返回</el-button>
			</div>
		</div>
	</div>
</template>

<script>
const svgReq = require.context("../edu/edu-info/teacher-manager/img", false, /\.svg$/);
const svgMap = svgReq.keys().reduce((map, key) => {
	const mod = svgReq(key);
	const name = key.replace("./", "").replace(".svg", "");
	map[name] = mod && mod.default ? mod.default : mod;
	return map;
}, {});
import jcxx from "../edu/edu-info/teacher-manager/img/jcxx.svg";
import zy from "../edu/edu-info/teacher-manager/img/zy.svg";
import zc from "../edu/edu-info/teacher-manager/img/zc.svg";
import gr from "../edu/edu-info/teacher-manager/img/gr.svg";
import img_ from "@/assets/img/photo_boy.png";

export default {
	data() {
		return {
			jcxx: jcxx,
			zy: zy,
			zc: zc,
			gr: gr,
			img_: img_,
			form: {},
			value: "",
			inputValue: "",
			options: [],
			nationArr: [],
			subjectArr: [],
			inputVisible: false,
			disabled: false,
			xjList: Array.from({ length: 7 }, (_, i) => svgMap[String(i)]),
			educationLevels: [
				{ value: 7, label: "博士研究生" },
				{ value: 6, label: "硕士研究生" },
				{ value: 5, label: "本科" },
				{ value: 4, label: "专科" },
				{ value: 3, label: "高中" },
				{ value: 2, label: "初中" },
				{ value: 1, label: "小学" }
			],
			genderArr: [
				{ value: 2, label: "男" },
				{ value: 1, label: "女" }
			],
			first: 1
		};
	},
	methods: {
		showInput() {
			if (this.form.tags.length >= 6) return this.$message.warning("最多填写6个标签");
			this.inputVisible = true;
			this.$nextTick((_) => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
		},
		handleInputConfirm() {
			if (this.inputValue.length <= 0) return (this.inputVisible = false);
			this.form.tags.push(this.inputValue);
			this.inputValue = "";
			this.inputVisible = false;
		},
		onDeleteTag(tag) {
			this.form.tags.splice(this.form.tags.indexOf(tag), 1);
		},
		handleChange(val) {
			console.log(val);
		},
		isPureChinese(text) {
			const chineseRegex = /^[\u4e00-\u9fa5]+$/;
			return chineseRegex.test(text);
		},
		id_cardBlur() {
			console.log(this.getBirthdayFromIdCard(this.form.id_card));
			if (this.getBirthdayFromIdCard(this.form.id_card) !== "") this.form.birthday = this.getBirthdayFromIdCard(this.form.id_card);
			this.$forceUpdate();
		},
		getBirthdayFromIdCard(idCard) {
			if (idCard.length === 18) {
				let birthDate = idCard.substr(6, 8);
				let year = birthDate.substr(0, 4);
				let month = birthDate.substr(4, 2);
				let day = birthDate.substr(6, 2);
				return `${year}-${month}-${day}`;
			}
			return "";
		},

		onChange(file) {
			this.form.avator = file.data.file_addr;
		},
		onChange_(file) {
			this.form.photo = file.data.file_addr;
		},
		beforeAvatarUpload(file) {
			const isJPG = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
			const isLt2M = file.size / 1024 / 1024 < 20;

			if (!isJPG) {
				this.$message.error("上传头像图片只能是 pjpeg或jpeg或jpg或png 格式!");
				return false;
			}
			if (!isLt2M) {
				this.$message.error("上传头像图片大小不能超过 20MB!");
				return false;
			}
			return true;
		},
		onChangea() {
			this.$methods.console.error("上传出错请重试");
		},
		onSubmit() {
			this.$_axios2.post("api/teacher/account/edit", this.form, { logic: 1 }).then((res) => {
				this.$message.success("修改成功");
				this.$_axios2.get("api/teacher/account/info").then((res) => {
					this.form = res.data.data;
					this.form.education = Number(res.data.data.education);
					this.form.nation = Number(res.data.data.nation);
					// this.form.subject = [String(res.data.data.fist_subject_id), String(res.data.data.subject_id)]
					if (res.data.data.education == 0) this.form.education = "";
					if (res.data.data.nation == 0) this.form.nation = "";
					this.first = this.form.first;
					if (this.form.first_success == 2) this.disabled = true;
				});
			});
		}
	},
	created() {
		this.$_axios2.get("api/teacher/account/info").then((res) => {
			this.form = res.data.data;
			this.form.education = Number(res.data.data.education);
			this.form.nation = Number(res.data.data.nation);
			// this.form.subject = [String(res.data.data.fist_subject_id), String(res.data.data.subject_id)]
			if (res.data.data.education == 0) this.form.education = "";
			if (res.data.data.nation == 0) this.form.nation = "";
			this.first = this.form.first;
			if (this.form.first_success == 2) this.disabled = true;
		});
		this.$_axios2.get("api/common/nation").then((res) => {
			this.nationArr = res.data.data;
		});
		this.$_axios.get("site/subject").then((res) => {
			this.subjectArr = res.data.data;
		});
	}
};
</script>
<style lang="scss" scoped>
.grid2 {
	display: grid;
	grid-template-columns: 574rem 1fr;
}
</style>
<style>
.t-watermark-box {
	width: 100% !important;
}

.credentials-item {
	padding: 24rem;
}

.credentials-item-key {
	color: #888888;
	display: inline-block;
}

.credentials-item-key-left {
	width: 84rem;
}

.credentials-item-key-right {
	width: 116rem;
}

.credentials-item-val {
	color: #3c3c3c;
  width: 90rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>
